import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { servicesUrl } from 'src/app/services/servicesUrl';
import { HomeService } from '../../services/home.service';

@Component({
  selector: 'app-research-topic-details',
  templateUrl: './research-topic-details.component.html',
  styleUrls: ['./research-topic-details.component.css']
})
export class ResearchTopicDetailsComponent implements OnInit {

  constructor(private _Activatedroute: ActivatedRoute,private homeService_: HomeService,private imgUrl_:servicesUrl) {
  }

 id:any
 ResearchTopicName:string = ''
 ResearchTopicDsc:string = ''
 ResearchTopicDetails:string = ''
 ResearchTopicImg:string = ''
 load:boolean=false
 selectedItem: any
 arrayResearchTopicCategroy:any
 arrayResearchTopics:any

 ngOnInit(): void {
this.load = false;
this.id = this._Activatedroute.snapshot.paramMap.get("id")
this.homeService_.getPost('getPost','', 'en', '', 'ResearchTopicCategroy', 'NTROOT0', '', '-1').subscribe(data => {
 this.arrayResearchTopicCategroy = data



 this.homeService_.getPost('getPostById',this.id, 'en', '', 'ResearchTopics', '', '', '1').subscribe(data => {
   let arr = data as any[]
   this.ResearchTopicName = arr[0]['postTitle']
   this.ResearchTopicDsc = arr[0]['postSubTitle']
   this.ResearchTopicDetails = arr[0]['postDetails']
   this.ResearchTopicImg = this.imgUrl_.imgUrl+arr[0]['postImage']
   this.load = true
 })
 });


 }

}
